"use client";

import { useTranslation } from "react-i18next";
import { Icon } from "@iconify-icon/react";
import { motion } from "motion/react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface SwitchLessonDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function SwitchLessonDialog({
  isOpen,
  onClose,
  onConfirm,
}: SwitchLessonDialogProps) {
  const { t } = useTranslation(["common", "classroom"]);

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent className="bg-background border-border max-w-[400px] rounded-xl">
        <AlertDialogHeader>
          <motion.div
            animate={{ scale: 1, opacity: 1 }}
            className="mb-2 flex justify-center"
            initial={{ scale: 0.9, opacity: 0 }}
          >
            <div className="bg-destructive/10 text-destructive flex h-12 w-12 items-center justify-center rounded-full">
              <Icon height="24" icon="lucide:alert-triangle" width="24" />
            </div>
          </motion.div>
          <AlertDialogTitle className="text-accent-foreground">
            {t("classroom:errors.switchLessonConfirmTitle")}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-muted-foreground">
            {t("classroom:errors.switchLessonConfirmDescription")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col space-y-2 sm:space-y-0">
          <AlertDialogAction
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90 w-full"
            onClick={onConfirm}
          >
            {t("classroom:errors.switchLesson")}
          </AlertDialogAction>
          <AlertDialogCancel
            className="border-border text-accent-foreground mt-0 w-full"
            onClick={onClose}
          >
            {t("common:cancel")}
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
